import { notification } from '../components/Common/Notification';

export const successNotification = (title: string): void => {
  notification(title, 'success');
};

export const errorNotification = (title: string): void => {
  notification(title, 'error');
};
